<template>
  <StructureUnitCommentTypeTextField
    :pageValue="INSPECTION_PAGES.SUPERSTRUCTURE"
    :id="`textarea_superstructure_notes_girders_beams`"
    :inspectionCommentType="INSPECTION_COMMENTS.SUPER_GIRDERS"
    :readOnly="!isEditable"
    label="Girders/Beams"
    :counter="commentsMaxLength"
    :maxlength="commentsMaxLength"
    :structureUnitId="structureUnitId"
    @updateComment="isDirty = true"
  />
  <StructureUnitCommentTypeTextField
    :pageValue="INSPECTION_PAGES.SUPERSTRUCTURE"
    :id="`textarea_superstructure_notes_floorbeams`"
    :inspectionCommentType="INSPECTION_COMMENTS.SUPER_FLOORBEAMS"
    :readOnly="!isEditable"
    label="Floorbeams"
    :counter="commentsMaxLength"
    :maxlength="commentsMaxLength"
    :structureUnitId="structureUnitId"
    @updateComment="isDirty = true"
  />
  <StructureUnitCommentTypeTextField
    :pageValue="INSPECTION_PAGES.SUPERSTRUCTURE"
    :id="`textarea_superstructure_notes_stringers`"
    :inspectionCommentType="INSPECTION_COMMENTS.SUPER_STRINGERS"
    :readOnly="!isEditable"
    label="Stringers"
    :counter="commentsMaxLength"
    :maxlength="commentsMaxLength"
    :structureUnitId="structureUnitId"
    @updateComment="isDirty = true"
  />
  <StructureUnitCommentTypeTextField
    :pageValue="INSPECTION_PAGES.SUPERSTRUCTURE"
    :id="`textarea_superstructure_notes_diaphragms`"
    :inspectionCommentType="INSPECTION_COMMENTS.SUPER_DIAPHRAGMS"
    :readOnly="!isEditable"
    label="Diaphragms"
    :counter="commentsMaxLength"
    :maxlength="commentsMaxLength"
    :structureUnitId="structureUnitId"
    @updateComment="isDirty = true"
  />
  <StructureUnitCommentTypeTextField
    :pageValue="INSPECTION_PAGES.SUPERSTRUCTURE"
    :id="`textarea_superstructure_notes_truss_members`"
    :inspectionCommentType="INSPECTION_COMMENTS.SUPER_TRUSS_MEMBERS"
    :readOnly="!isEditable"
    label="Truss Members"
    :counter="commentsMaxLength"
    :maxlength="commentsMaxLength"
    :structureUnitId="structureUnitId"
    @updateComment="isDirty = true"
  />
  <StructureUnitCommentTypeTextField
    :pageValue="INSPECTION_PAGES.SUPERSTRUCTURE"
    :id="`textarea_superstructure_notes_portals_bracings`"
    :inspectionCommentType="INSPECTION_COMMENTS.SUPER_PORTALS"
    :readOnly="!isEditable"
    label="Portals/Bracings"
    :counter="commentsMaxLength"
    :maxlength="commentsMaxLength"
    :structureUnitId="structureUnitId"
    @updateComment="isDirty = true"
  />
  <StructureUnitCommentTypeTextField
    :pageValue="INSPECTION_PAGES.SUPERSTRUCTURE"
    :id="`textarea_superstructure_notes_drainage_system`"
    :inspectionCommentType="INSPECTION_COMMENTS.SUPER_DRAINAGE"
    :readOnly="!isEditable"
    label="Drainage System"
    :counter="commentsMaxLength"
    :maxlength="commentsMaxLength"
    :structureUnitId="structureUnitId"
    @updateComment="isDirty = true"
  />
  <StructureUnitCommentTypeTextField
    :pageValue="INSPECTION_PAGES.SUPERSTRUCTURE"
    :id="`textarea_superstructure_notes_combustible_materials_under_bridge`"
    :inspectionCommentType="INSPECTION_COMMENTS.COMBUSTIBLE_MATERIALS_UNDER_BRIDGE"
    :readOnly="!isEditable"
    label="Combustible Materials Under Bridge"
    :counter="commentsMaxLength"
    :maxlength="commentsMaxLength"
    :structureUnitId="structureUnitId"
    @updateComment="isDirty = true"
  />
</template>
<script setup>
import { computed, toRefs } from "vue";
import { useConfigStore } from "@/stores/config";
import { useSuperstructureStore } from "@/components/inspection/store/superStructure";
import { ENV_CONFIG_PROPERTY } from "@/constants/EnvConfigProperties";
import StructureUnitCommentTypeTextField from "@/components/inspection/spanBySpanComponents/StructureUnitCommentTypeTextField.vue";
import { INSPECTION_COMMENTS, INSPECTION_PAGES } from "@/constants/Inspections";
import { storeToRefs } from "pinia";

const props = defineProps({
  structureUnitId: Number,
});
const { structureUnitId } = toRefs(props);
const store = useSuperstructureStore();
const { isEditable, isDirty } = storeToRefs(store);
const configStore = useConfigStore();
const commentsMaxLength = computed(() => {
  return configStore.getEnvConfigValue(ENV_CONFIG_PROPERTY.INSPECTION_COMMENT_MAX_LENGTH);
});
</script>
